import { component as defineComponent } from 'flightjs';

var PaymentsModalHandler = function() {
    this.attributes({
        showEvent: undefined,
        asyncShowPrepareEvent: undefined,
        asyncShowFinishEvent: undefined,
        abortEvent: undefined,
    });

    this.after('initialize', function() {
        this.on(document, this.attr.showEvent, this.syncShow);
        this.on(document, this.attr.abortEvent, this.abort);
        this.on(document, this.attr.asyncShowPrepareEvent, this.asyncPrepare);
        this.on(document, this.attr.asyncShowFinishEvent, this.asyncFinish);

        // Keep track of the payment modal loaded state so that we can queue up payment
        // modal method calls until everything has been fully initialized.
        this.paymentsLoaded = $.Deferred();
        if (
            window.payments &&
            window.payments.paymentModal &&
            window.payments.paymentModal.isAvailable
        ) {
            this.paymentsLoaded.resolve();
        } else {
            window.addEventListener('Payments.app.available', this.paymentsLoaded.resolve);
        }

        // Handle custom events coming from modal
        // e.g. emit contests specific events for component usage
        window.addEventListener(
            'Payments.app.visible',
            function() {
                this.handleApplicationVisibleEvent();
            }.bind(this)
        );
    });

    this.syncShow = function(e, data) {
        if (!data.paymentsInput) {
            throw Error('Missing required paymentsInput');
        }

        window.payments.paymentModal.show(data.paymentsInput);
    };

    this.asyncPrepare = function(e, data) {
        window.payments.paymentModal.asyncShowPrepare();
    };

    this.asyncFinish = function(e, data) {
        if (!data.paymentsInput) {
            this.abort();
            throw Error('Missing required paymentsInput');
        }

        window.payments.paymentModal.asyncShowFinish(data.paymentsInput);
    };

    this.abort = function(e, data) {
        window.payments.paymentModal.abort();
    };

    this.handleApplicationVisibleEvent = function(e) {
        this.trigger('uiPaymentsModalVisible');
    };

    this.queuePaymentFunction = function(paymentFunc, e, data) {
        this.paymentsLoaded.done(function() {
            paymentFunc(e, data);
        });
    };

    this.around('syncShow', this.queuePaymentFunction);
    this.around('asyncPrepare', this.queuePaymentFunction);
    this.around('asyncFinish', this.queuePaymentFunction);
};

export default defineComponent(PaymentsModalHandler);



// WEBPACK FOOTER //
// ./src/web/js/payments/data/payments-modal-handler.js